// @ts-nocheck
import { rootReducer } from './reducers';
import { configureStore } from '@reduxjs/toolkit';
import { mediaProbeApi } from '../../../media/api/mediaProbeApi';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(mediaProbeApi.middleware),
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
